import React, { useState, useEffect, useCallback } from 'react'
import { withOidcSecure } from '@axa-fr/react-oidc'
import { width } from "../../../CustomComponents/DynamicCard/DynamicCardStyles";
import { useTranslation } from 'react-i18next';
import HomeLayout from '../../../Layout/HomeLayout';
import DynamicCard from '../../../CustomComponents/DynamicCard';
import { useLocation, useNavigate } from 'react-router';
import { addLineBreaks, ClimbManageSettingsSidebar, dashBoardformatDate, retrieveData } from '../../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../CustomComponents/Loader';
import { CLIMB_OPT_IN_OUT, COVERED_BY_KUDZU, COVERED_BY_KUDZU_PLUS, GET_ALL_SPEND_ALERTS, GET_CLIMB_FEATURES, GET_KUDZUPLUS_COVERAGE, GET_REPAID_TRANSACTIONS, OPT_FEATURE_DY, OPT_IN_FEATURE, OPT_IN_FEATURE_DY, OPT_IN_FEATURE_SPEND_ALERTS, OPT_OUT_FEATURE, OPT_OUT_FEATURE_SPEND_ALERTS, SAVINGS_GOALS, SPENDING_ALERT, STATUS_SUCCESS_CODE } from '../../../../network/URLConstants';
import Modal from '../../../CustomComponents/Modal';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../../network/NetworkUtils';
import SpendAlertsPause from "../../../../assets/images/illo-pause.png";
import SpendAlertsPauseSuccess from '../../../../assets/images/illo-pause-done.png';
import Success from '../Success';
import CustomAlertModel from '../../../CustomComponents/CustomAlertModel';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import { appTheme } from '../../../../helpers/utils/Utils';
import CardHeading from '../../../CustomComponents/CardHeading';
import HelpPlus from '../../../../assets/kudzu-plus-images/HelpPlus.png';
import VerticalProgressBar from '../../../CustomComponents/VerticalProgressBar';
import lockIcon from '../../../../assets/kudzu-plus-images/lock.png';
import coveredBykudzuplus2 from '../../../../assets/kudzu-plus-images/coveredBykudzuplus-2.png';
import coveredBykudzuplus1 from '../../../../assets/kudzu-plus-images/coveredBykudzuPlusGradientIntro1.png';
import debounce from 'lodash.debounce';
import ManageCBKTransactions from '../../../CustomComponents/ManageCBKTransactions';
import { getUserMembership } from '../../../../helpers/utils/Utils';

const ManageCoveredByKudzu = () => {
    const HeadingStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[#2965FB]";
    const SubHeadingStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-heading-clr)]";
    const location = useLocation();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const SettingsData = [
        {
            title: 'Covered by Kudzu',
            content: 'You can opt out of Covered by Kudzu at any time. You must opt back in to resume this coverage.'

        }
    ];
    const fundsFromCBKplus = [
        {
            title: 'Funds from Kudzu+',
            content: 'You can opt out of Covered by Kudzu at any time. You must opt back in to resume this coverage.'

        }
    ];

    const [isLoading, setIsLoading] = useState(false);
    const accessToken = useSelector(state => state.accessToken);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const isPrimrayKey = cards !== null ? cards !== null ? cards[0].CardKey : 0 : 0;
    const climbFeatures = useSelector(state => state.climbFeatures);
    const enabledClimbings =   climbFeatures?.filter((response) => response?.enabled === true);
    const isCoveredByKudzuOptedIn = enabledClimbings?.some(item => item.code === COVERED_BY_KUDZU && item?.optedIn)
    const isCoveredByKudzuOptedInForPlus = enabledClimbings?.find(item => item.code === COVERED_BY_KUDZU )
    const isCoveredByKudzuPlusOptedIn = enabledClimbings?.find(item => item.code === COVERED_BY_KUDZU_PLUS)
    const CBKPlusObject = enabledClimbings?.filter((val) => val?.code == COVERED_BY_KUDZU_PLUS);
    
       const accessTokenToApi = useSelector(state => state.accessToken);
        const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
        const userMembershipData = getUserMembership(loggedResponse)
    
    
        const handleTermsClick = () =>{
            if (accessTokenToApi == undefined || accessTokenToApi == null) {
              return;
          }
          else {
              navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions', 
                url:
                userMembershipData?.membershipType === "Plus" ||
                userMembershipData?.membershipType === "Trial"
                ? "CoveredByKudzuPlusTerms"
                : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey } });
          
          }
          }
    
    const [showModel, setShowModel] = useState(false);
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal  text-[var(--modal-text-highlight)]  cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none  text-[var(--modal-text-heading-clr)]";
    const SubHeaderMsgStyles = " text-[var(--modal-text-heading-clr)] font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const SubHeadingStyles2 = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-text-highlight)] mb-4";
    
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [modelImage, setModelImage] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);
    const [selectedItem, setSelectedItem] = useState(false);
    const [viewDetailsTrue, setViewDetailsTrue] = useState(false)
    const [showLearnMoreButton, setShowLearnMoreButton] = useState(false);
    const [showActivateButton, setShowActivateButton] = useState(false);
    const [isCoveredByKudzuPlusModalOpen1, setIsCoveredByKudzuPlusModalOpen1] = useState(false);
    const [isCoveredByKudzuPlusModalOpen2, setIsCoveredByKudzuPlusModalOpen2] = useState(false);
    const [isCoveredByKudzuPlusIneligible, setIsCoveredByKudzuPlusIneligible] = useState(false);
    const [repaidTransactionData, setRepaidTransactionData] = useState([]);
    const [unpaidTransactionData, setUnpaidTransactionData] = useState(false);
    const [cbkCoverageData, setCbkCoverageData] = useState(false);
    const [userDataPercentage, setUsedPercentageData] = useState(false);
    const [limit, setLimit] = useState('');
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [showToolTipForCbk, setShowToolTipForCbk] = useState(false);
    const [showToolTipForCbkPlus, setShowToolTipForCbkPlus] = useState(false);
    const issavingsGoalEligible = enabledClimbings?.find(item => item?.code === SAVINGS_GOALS);
    const isSavingsGoalsOptedIn = enabledClimbings?.some(item => item.code === SAVINGS_GOALS && item.optedIn)


    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, showErrorImg, isBorderNone) => {
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
    }

    const closeCustomAlertModal = () => { 
        if (headerMsg == t('covered_by_kudzu_paused')) { navigate('/Climb/ClimbMenu') }
        else { setShowModel(false); }
    }

    const onAcptBtnClick = async () => {
        setShowModel(false)
        if ((btn1Text == t("pause_covered_by_kudzu") || btn1Text == t("pause_covered_by_kudzuPlus"))) {
            optOutOfCbKApiCall(selectedItem)
        } else if (btn1Text == t('back_to_climb')) {
            logFirebaseEvents("Manage_Covered_By_Kudzu", "BackTo_Climb_Manage_Covered_Clicked", "BackTo_Climb_Manage_Covered_Clicked","", "");
            navigate('/Climb/ClimbMenu')
        }
    }
    const onCancelBtnClick = () => {
        logFirebaseEvents("Manage_Covered_By_Kudzu", "BackTo_Manage_Covered_Clicked", "BackTo_Manage_Covered_Clicked","", "");
        closeCustomAlertModal()
     }


    const optOutCBK = (isCBKPlus) => {  
        logFirebaseEvents("Manage_Covered_By_Kudzu", "Opt_Out_Of_Covered_Clicked ", "Opt_Out_Of_Covered_Clicked ","", "")
        showAlertModal(true, t('are_you_sure'),isCBKPlus ? t('CoverdByKudzuPlusPauseMessage') :  t("CoverdByKudzuPauseMessage"),isCBKPlus ? (<>{(t('CBK_PLUS_SUB_HEADING'))}<span className='underline cursor-pointer' onClick={handleTermsClick}>{addLineBreaks(t("CBK_PLUS_LINK"))}</span>{t("You_can_opt")}</>) : t("opting_out_of_covered_by_kudzu"), true, true,isCBKPlus ? t('pause_covered_by_kudzuPlus') : t('pause_covered_by_kudzu'), t('cancel'), true, appThemeData.isButton, '', false, false)
    }




    const optOutOfCbKApiCall = async (isCBKPlus) => {  
        logFirebaseEvents("Manage_Covered_By_Kudzu", "Opt_Out_Of_Covered_Clicked", "Opt_Out_Of_Covered_Clicked","", "");
        setIsLoading(true)
        if(isCBKPlus){
        var url = CLIMB_OPT_IN_OUT.replace('{CARD_KEY}', isPrimrayKey) + 'CoveredByKudzuPlus' + '/opt-out'
        }else{
        var url = CLIMB_OPT_IN_OUT.replace('{CARD_KEY}', isPrimrayKey) + 'CoveredByKudzu' + '/opt-out'
        }
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const response = await PostRequest(url, {}, headers);
        const responseObj = JSON.parse(response)
        // debugger;
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            handleClimbFeatures()
            showAlertModal(true, t('done_exclamation'),isCBKPlus ? addLineBreaks(t('covered_by_kudzu_Plus_paused')) :  addLineBreaks(t("covered_by_kudzu_paused")), isCBKPlus ? addLineBreaks(t('you_may')) : <><span className='w-[452px]'>{t("opt_out_of_covered_by_kudzu_msg")}</span></>, true, false, t('back_to_climb'), '', true, appThemeData.isSuccesstelusko, '', false, false)

        } else {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("oops_exclamation"), '', displayText, true, true, t('back_to_climb'), '', true, require('../../../../assets/images/warning.png'), '', false, false)

        }
    }

    const handleClimbFeatures = async () => {
        if (isPrimrayKey == undefined || isPrimrayKey == null) {
            return
        }
        //  debugger;
        setIsLoading(true);
        const deviceId = await retrieveData('updatedDeviceId')
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const url = GET_CLIMB_FEATURES.replace('{CARD_KEY}', isPrimrayKey)
        const response = await GetRequest(url, headers);
        const responseJson = JSON.parse(response);
        if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
            dispatch({ type: 'UPDATE_CLIMB_FEATURE', payload: { climbFeatures: responseJson.Response } })
            setIsLoading(false);
        } else {
            return [];
        }

    }

    ///////////////////////////////////HANDLE PAUSE AND RESUME MODAL POPUS  4

    // const ManageSettingsbuttonLabels = [
    //     { label: 'SpendSense Alerts', link: '/Climb/ManageSpendAlerts' },
    //     { label: 'Covered by Kudzu', link: isCoveredByKudzuOptedIn ? '/Climb/ManageCoveredByKudzu' : '/Climb/CoveredByKudzu' },
    //     { label: 'Savings Habits', link: '/Climb/ManageSavingsHabit' },
    // ];
    const ManageSettingsbuttonLabels = [
        { label: 'SpendSense Alerts', link: '/Climb/ManageSpendAlerts' },
        // { label: 'Covered by Kudzu', link: (isCoveredByKudzuOptedIn || isCoveredByKudzuPlusOptedIn) ? '/Climb/ManageCoveredByKudzu' : '/Climb/CoveredByKudzu' },
        { label: 'Covered by Kudzu', link: kudzuPlusTrue ? (isCoveredByKudzuOptedIn || isCoveredByKudzuPlusOptedIn) ? '/Climb/ManageCoveredByKudzu' : '/Climb/CoveredByKudzu' : isCoveredByKudzuOptedIn ? '/Climb/ManageCoveredByKudzu' : '/Climb/CoveredByKudzu' },
        { label: 'Savings Habits', link: '/Climb/ManageSavingsHabit' },
        ...(issavingsGoalEligible ? [{ label: 'Savings Goals', link: isSavingsGoalsOptedIn ? '/Climb/SavingGoals/ManageSavingGoal' : '/Climb/ClimbSettings' }] : []),
    ];
    const navigateClicked = (item) => {
        navigate(item.link)
    }

     const handleToggleButton = (index, item, optIn) => {
        debugger
        if (optIn) {
            if (item == COVERED_BY_KUDZU_PLUS) {
                optOutCBK(item)
                setSelectedItem(item)
                logFirebaseEvents("Manage_Covered_By_Kudzu", "Covered_By_Kudzu_Plus_optout_clicked", "Covered_By_Kudzu_Plus_optout_clicked", "", "");
            }
            else {
                logFirebaseEvents("Manage_Covered_By_Kudzu", "Covered_By_Kudzu_optout_clicked", "Covered_By_Kudzu_optout_clicked", "", "");
                optOutCBK()
            }
        } else {
            if (item == COVERED_BY_KUDZU) {
                logFirebaseEvents("Manage_Covered_By_Kudzu", "Covered_By_Kudzu_optin_clicked", "Covered_By_Kudzu_optin_clicked", "", "");
                navigate('/Climb/CoveredByKudzu', { state: 'optinForCBK' });
            }
            else if (item == COVERED_BY_KUDZU_PLUS) {
                logFirebaseEvents("Manage_Covered_By_Kudzu", "Covered_By_Kudzu_Plus_optin_clicked", "Covered_By_Kudzu_Plus_optin_clicked", "", "");
                navigate('/Climb/CoveredByKudzuPlus', { state: 'optinForCBKplus' });
            }
         }

        }


    const handleViewDetails = () => {
        getBKPlusCoverage()
    }

    
  useEffect(() => {
    if (location.state?.autoViewDetails) {
      handleViewDetails();
    }
  }, [location.state]);

    useEffect(() => {
        if (CBKPlusObject != undefined && CBKPlusObject?.length > 0) {
            const isEligible = CBKPlusObject[0].isEligible
            const hasEverOptedIn = CBKPlusObject[0].hasEverOptedIn
            //  setEverOptedIn(hasEverOptedIn)
            const optedIn = CBKPlusObject[0].optedIn
            if (!isEligible && !optedIn) {
                setShowLearnMoreButton(true)
            } else if (!hasEverOptedIn && !optedIn) {
                setShowActivateButton(true)
            } else {
                //-----------displaying existing toggle--------
            }
        }
    }, [CBKPlusObject])

    const handleActivateCoveredByKudzuPlus = () => {
        setIsCoveredByKudzuPlusModalOpen1(false)
        setIsCoveredByKudzuPlusModalOpen2(false)
        if (showActivateButton) {
            setIsCoveredByKudzuPlusIneligible(false)
            // setIsCoveredByKudzuDiscloserOpen(true);
            navigate('/Climb/CoveredByKudzuPlus', { state: 'optinForCBKplus' });

        }
        else {
            // setIsCoveredByKudzuDiscloserOpen(false);
            setIsCoveredByKudzuPlusIneligible(true)
        }
    }
    const closeCBKPlusModals = () => {
        setIsCoveredByKudzuPlusModalOpen1(false)
        setIsCoveredByKudzuPlusModalOpen2(false)
    } 
    const getBKPlusCoverage = async() =>{
          if (cards[0]?.CardKey == undefined || cards[0]?.CardKey == null) {
                    return
                }
                setIsLoading(true)
                let url = GET_KUDZUPLUS_COVERAGE(cards[0]?.CardKey)
                const deviceId = await retrieveData('updatedDeviceId');
                const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
                var response = await GetRequest(url, headers)
                var responseObj = JSON.parse(response);
                if (responseObj?.ResponseCode == STATUS_SUCCESS_CODE) {
                    const resData = responseObj?.Response
                    setCbkCoverageData(resData)
                    setUnpaidTransactionData(resData?.unPaidTransactions)
                    const usedPercentage = (resData?.overdraftAmountUsed / resData?.overdraftLimit) * 100
                    setUsedPercentageData(usedPercentage)
                    setLimit(resData?.overdraftLimit)
                    getRepaidTransactions()
                } else {
                    var arrMessages = responseObj.Messages;
                    var message = arrMessages[0];
                    var displayText = message.DisplayText;
                }
    }

       const handleTermsClicks = () =>{
        if (accessTokenToApi == undefined || accessTokenToApi == null) {
          return;
      }
      else {
          navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions', 
            url:
            userMembershipData?.membershipType === "Plus" ||
            userMembershipData?.membershipType === "Trial"
            ? "CoveredByKudzuPlusTerms"
            : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey } });
      
      }
      }
    

const getRepaidTransactions = useCallback(async () => {
    if (isLoading || !hasMore) return; // Prevent duplicate API calls
    setIsLoading(true);

    try {
        // Check for valid CardKey
        if (!cards[0]?.CardKey) return;

        const url = GET_REPAID_TRANSACTIONS(cards[0]?.CardKey, page);
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const response = await GetRequest(url, headers);
        const responseObj = JSON.parse(response);

        if (responseObj?.ResponseCode === STATUS_SUCCESS_CODE) {
            const data = responseObj?.Response?.Items || [];
            console.log("Data:", data);
            setViewDetailsTrue(true)
            if (data.length === 0) {
                setHasMore(false); // No more data to fetch
            } else {
                setRepaidTransactionData((prevData) => [...prevData, ...data]); // Append new data
                setPage((prevPage) => prevPage + 1); // Increment page
            }
        } else {
            console.error("Error:", responseObj?.Messages?.[0]?.DisplayText);
        }
    } catch (error) {
        console.error("Error fetching data:", error);
    } finally {
        setIsLoading(false);
    }
}, [page, isLoading, hasMore]);

const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 1 && !isLoading && hasMore) {
        getRepaidTransactions(); // Trigger the API call for the next page
    }
};

const handleToolTipForCBK = () => {
    if (showToolTipForCbk) {
        setShowToolTipForCbkPlus(false)
        setShowToolTipForCbk(false)
    }
    else {
        setShowToolTipForCbkPlus(false)
        setShowToolTipForCbk(true)
    }
}
const handleToolTipForCBKPlus = () => {
    if (showToolTipForCbkPlus) {
        setShowToolTipForCbk(false)
        setShowToolTipForCbkPlus(false)
    }
    else {
        setShowToolTipForCbk(false)
        setShowToolTipForCbkPlus(true)
    }

}


    return (
        <>
            <HomeLayout>
                <ClimbManageSettingsSidebar indexBtn={2} ManageSettingsbuttonLabels={ManageSettingsbuttonLabels} headingMessage={true} navigateClicked={navigateClicked} />
                <div className='flex flex-col md:w-[860px] sm:w-[464px] 
            w-[100%] animate__animated animate__fadeInRight '>
                    <DynamicCard
                        header={false}
                        CardRadius={true}
                        cardWidth={width.homeCard}
                        HeaderRadius={true}
                        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        backgroundColor={'--cardHeading-bg'}
                        HeaderContent={
                            <>
                                <CardHeading heading={t('manage_covered_by_kudzu')} />
                            </>
                        }
                        footer={true}
                    >
                        <div style={{ minHeight: '660px' }}>
                            {/* <div class=" lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500]
                             lg:text-[26px] md:text-[22px] sm:text-[20px] text-[20px] leading-[36px]
                              font-hanken-grotesk sm:mx-0 mx-4">{(t('manage_covered_by_kudzu'))}</div> */}

                            <div class={`${kudzuPlusTrue ? '' : 'border-[#A3CEBB] border-b-[3px]'} sm:mx-0 mx-4`}></div>

                            <div className='justify-center flex lg:mt-8 md:mt-6 sm:mx-0 mx-4'>
                                {!viewDetailsTrue &&
                                    <div className='lg:w-[70%] sm:w-[81%] w-full'>

                                        <>
                                            {!kudzuPlusTrue && SettingsData.map((settings, index) => (
                                                <div key={index} className='mt-10 flex justify-between md:h-[123px]
                                         sm:h-[140px] h-[123px]
                                             border-b-[2px] border-[var(--settings-border-pop)] border-opacity-[65%]'>
                                                    <div>
                                                        <p className='lg:text-[20px] md:text-[18px] 
                                                    sm:text-[17px] text-[17px] font-hanken-grotesk 
                                                    leading-[30px] sm:font-[500] font-[600] text-[var(--settings-clrs-pop)]'>
                                                            {settings.title}
                                                        </p>
                                                        <div className='mt-4 lg:text-[14px] 
                                                    md:text-[13px] sm:text-[14px] text-[14px] 
                                                    font-hanken-grotesk lg:leading-[20px] md:leading-[18px]
                                                     sm:leading-[23px] leading-[20px] sm:font-[400] font-[500] sm:w-auto w-[240px] text-[var(--settings-pop-content-clr)]'>
                                                            {settings.content}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label class="relative inline-flex items-center cursor-pointer">
                                                            <input type="checkbox"
                                                                checked={isCoveredByKudzuOptedIn}
                                                                onChange={(e) => { optOutCBK() }}
                                                                class="sr-only peer"
                                                                onClick={(e) => optOutCBK()}
                                                                disabled={!isCoveredByKudzuOptedIn}
                                                                tabIndex={0}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "Enter") {
                                                                        optOutCBK()
                                                                    }
                                                                }
                                                                }
                                                            />
                                                            <div class="w-[38px] h-[25px]  bg-[#4B70B9] bg-opacity-[40%]
                                     peer-focus:outline-none   
                                      rounded-full peer dark:bg-gray-700 
                                      peer-checked:after:translate-x-full
                                     peer-checked:after:border-[var(--peer-checked-color)] 
                                      peer-checked:after:bg-[var(--peer-checked-color)]
                                      peer-checked:after:left-[-6px]
                                      after:content-[''] 
                                      after:absolute after:top-[2px]
                                      after:left-[2px] after:right-0
                                      after:bg-[#fff]
                                       after:border-[#fff] after:border-[gray-300] 
                                      after:border after:rounded-full after:h-[21px] 
                                      after:w-[21px] after:transition-all
                                       dark:border-gray-600 peer-checked:bg-[var(--peer-checked-bg-color)] peer-checked:bg-opacity-[40%]"></div>

                                                            <span class="ml-3 text-sm font-medium text-gray-900
                                     dark:text-gray-300"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}

                                            {kudzuPlusTrue && SettingsData.flatMap((settings, index) => {
                                                const baseItem = (
                                                    <div
                                                        key={index}
                                                        className={`md:mt-10 mt-12 flex justify-between h-[123px]`}
                                                    >
                                                        <div>
                                                            <p className="md:text-[20px] md:leading-[30px] sm:text[13px] sm:leading-[19px] text-[16px] font-hanken-grotesk leading-[24px] font-600 md:font-[500] text-[var(--climbSettingsTitle)]">
                                                                {settings.title}
                                                            </p>
                                                            <div className="lg:w-[410px] sm:w-[321px] w-[240px] mt-4 md:text-[14px] sm:text-[10px] text-[14px] font-hanken-grotesk md:leading-[22px] sm:leading-[16px] leading-[20px] font-[500] md:font-[400] text-[var(--climb-font-clr)]">
                                                                {settings.content}
                                                            </div>
                                                        </div>

                                                    </div>
                                                );

                                                if (kudzuPlusTrue) {
                                                    return [
                                                        baseItem,
                                                        <>
                                                            <div
                                                                key={`additional-1-${index}`}
                                                                className="md:mt-6 mt-9 flex justify-between"
                                                            >
                                                                <div>
                                                                  <div className='flex flex-col gap-2 items-start'>
                                                                    <p className="flex items-center md:text-[19px] md:leading-[30px] sm:text[13px] sm:leading-[19px] text-[16px] font-hanken-grotesk leading-[24px] font-600 md:font-[500] text-[var(--climbSettingsTitle)]">
                                                                        {t('fromsavings')} <img src={HelpPlus} alt='' className='pl-5 cursor-pointer' onClick={handleToolTipForCBK} />
                                                                    </p>
                                                                    {/* <p className='font-hanken-grotesk font-medium text-[16px] leading-6 text-[#FFFFFF]'>{t('50Limit')}</p> */}

                                                                  </div>
                                                                    {showToolTipForCbk &&
                                                                        <div className={`sm:ml-[98px] absolute ml-[80px] mt-[-21px] w-[150px] font-hanken-grotesk leading-4
                                                                 font-bold 
                                                                p-[16px] bg-[#2965FB] text-white text-[12px] rounded-xl
                                                                  shadow-lg  z-10 cursor-pointer transition-all duration-1000`} onClick={() => setShowToolTipForCbk(false)}>
                                                                            <div className="tooltip-arrow"></div>
                                                                            {t('Covered_by_Kudzu_automatically_transfers')}
                                                                        </div>}
                                                                </div>
                                                                <div>
                                                                    <label className="relative inline-flex items-center cursor-pointer">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isCoveredByKudzuOptedInForPlus.optedIn}
                                                                            onChange={(e) => handleToggleButton(index, isCoveredByKudzuOptedInForPlus.code, isCoveredByKudzuOptedInForPlus.optedIn)}
                                                                            onClick={(e) => handleToggleButton(index, isCoveredByKudzuOptedInForPlus.code, isCoveredByKudzuOptedInForPlus.optedIn)}
                                                                            // disabled={!isCoveredByKudzuOptedIn}
                                                                            className="sr-only peer"
                                                                        />
                                                                        <div className="w-[38px] h-[25px] bg-[var(--climb-button-unchecked-bg-clr)] bg-opacity-[40%] peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-[var(--climb-button-slide-check-clr)] peer-checked:after:bg-[var(--climb-button-slide-check-clr)] peer-checked:after:left-[-6px] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:right-0 after:bg-[var(--climb-button-slide-unchecked-clr)] after:border-[var(--climb-button-slide-unchecked-clr)] after:border after:rounded-full after:h-[21px] after:w-[21px] after:transition-all dark:border-gray-600 peer-checked:bg-[var(--climb-button-slide-checked-bg-clr)] peer-checked:bg-opacity-[40%]"></div>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </>,
                                                        <>
                                                            {<div
                                                                key={`additional-2-${index}`}
                                                                className={`md:mt-14 mt-9 flex justify-between ${isCoveredByKudzuPlusOptedIn.optedIn ? "" : 'border-b-[2px] border-[var(--climbBorder-botttom-clr)] border-opacity-[50%] sm:border-opacity-[75%]'}  h-[95px]`}
                                                            >
                                                                <div>
                                                                <div className='flex flex-col gap-2 items-start'>
                                                                    <p className="flex items-center md:text-[19px] md:leading-[30px] sm:text[13px] sm:leading-[19px] text-[16px] font-hanken-grotesk leading-[24px] font-600 md:font-[500] text-[var(--climbSettingsTitle)]">
                                                                        {t('fromKudzu+')} <img src={HelpPlus} alt='' className='pl-5 cursor-pointer' onClick={handleToolTipForCBKPlus} />
                                                                    </p>
                                                                    <p className='font-hanken-grotesk font-medium text-[16px] leading-6 text-[#FFFFFF]'>{t('100Limit')}</p>
                                                                </div>
                                                                    {showToolTipForCbkPlus &&
                                                                        <div className={`sm:ml-[98px] absolute ml-[80px] mt-[-21px] w-[150px] font-hanken-grotesk leading-4
                                                                 font-bold 
                                                                p-[16px] bg-[#2965FB] text-white text-[12px] rounded-xl
                                                                  shadow-lg  z-10 cursor-pointer transition-all duration-1000`} onClick={() => setShowToolTipForCbkPlus(false)}>
                                                                            <div className="tooltip-arrow"></div>
                                                                            {t('Once_Savings_coverage_is_exhausted')}
                                                                        </div>}
                                                                </div>
                                                                <div>
                                                                    {showLearnMoreButton ? <button className='borderGradient flex gap-[6px] px-[14px] py-[7px] font-hanken-grotesk text-[10px]' onClick={() => {logFirebaseEvents("Manage_Covered_By_Kudzu", "Learn_More_Clicked", "Learn_More_Clicked", "", ""); setIsCoveredByKudzuPlusModalOpen1(true)}}>{t('learn_more_covered')}<img src={lockIcon} alt='lockIcon' /></button> :
                                                                        showActivateButton ? <button className='borderGradient flex gap-[6px] px-[25px] py-[7px] font-hanken-grotesk text-[10px]' onClick={() => {logFirebaseEvents("Manage_Covered_By_Kudzu", "Activate_Clicked", "Activate_Clicked", "", ""); setIsCoveredByKudzuPlusModalOpen1(true)}}>{t('activate')}</button> :
                                                                            (isCoveredByKudzuPlusOptedIn &&
                                                                                <label className="relative inline-flex items-center cursor-pointer">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={isCoveredByKudzuPlusOptedIn?.optedIn}
                                                                                        onChange={(e) =>
                                                                                            handleToggleButton(index, isCoveredByKudzuPlusOptedIn?.code, isCoveredByKudzuPlusOptedIn?.optedIn)
                                                                                        }
                                                                                        className="sr-only peer"
                                                                                    />
                                                                                    <div className="w-[38px] h-[25px] bg-[var(--climb-button-unchecked-bg-clr)] bg-opacity-[40%] peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-[var(--climb-button-slide-check-clr)] peer-checked:after:bg-[var(--climb-button-slide-check-clr)] peer-checked:after:left-[-6px] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:right-0 after:bg-[var(--climb-button-slide-unchecked-clr)] after:border-[var(--climb-button-slide-unchecked-clr)] after:border after:rounded-full after:h-[21px] after:w-[21px] after:transition-all dark:border-gray-600 peer-checked:bg-[var(--climb-button-slide-checked-bg-clr)] peer-checked:bg-opacity-[40%]"></div>
                                                                                </label>)}
                                                                </div>
                                                            </div>}
                                                        </>,
                                                        <>
                                                            {isCoveredByKudzuPlusOptedIn.optedIn &&
                                                                <div className='border-b-[2px] border-[var(--climbBorder-botttom-clr)] border-opacity-[50%] sm:border-opacity-[75%]  h-[95px]'>
                                                                    <button className='borderGradient flex gap-[6px] px-[80px] py-[10px] font-hanken-grotesk text-[12px] m-auto' onClick={() => {logFirebaseEvents("Manage_Covered_By_Kudzu", "View_Details_Clicked", "View_Details_Clicked", "", ""); handleViewDetails()}}>{t("view kudzu+_details")}</button>
                                                                </div>}
                                                        </>
                                                    ];
                                                }

                                                return baseItem;
                                            })}
                                            <p className="font-hanken-grotesk font-[600] lg:text-[16px] md:text-[15px] sm:text-[14px]
                                     text-[16px] leading-[24px] text-[var(--learn-pop-color)] w-[80%] pt-8" >{t("manage_savings_habit_content2")}
                                                <span className='text-[var(--PayPerks-Pop-color)] cursor-pointer' onClick={() => { navigate('/PayPerks') }}
                                                    tabIndex={0}
                                                    onKeyDown={(e) => { if (e.key === "Enter") navigate('/PayPerks') }}
                                                >{t("NavbarPerks")}</span></p>
                                        </>
                                    </div>
                                }

                                {/* from here funds from CBKPlus */}
                                {viewDetailsTrue &&
                                    <ManageCBKTransactions
                                        handleScroll={(e) => handleScroll(e)}
                                        fundsFromCBKplus={fundsFromCBKplus}
                                        userDataPercentage={userDataPercentage}
                                        usedAmountValue={parseFloat(cbkCoverageData?.overdraftAmountUsed)?.toFixed(2)}
                                        unpaidTransactionData={unpaidTransactionData}
                                        repaidTransactionData={repaidTransactionData}
                                        limit={limit}
                                    />
                                }

                            </div>
                        </div>
                    </DynamicCard>
                </div>
            </HomeLayout>
            <CustomAlertModel
                isOpen={showModel}
                onClose={closeCustomAlertModal}
                image={modelImage}
                highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
                    <span className={HeaderMsgStyles}> {headerMsg}</span></p>}
                // highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
                // HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
                showErrorImg={showErrorImg}
                isBorderNone={isBorderNone}
            />
            {isLoading && <Loader />}
            {isCoveredByKudzuPlusModalOpen1 && <Modal
                isOpen={isCoveredByKudzuPlusModalOpen1}
                onClose={debounce(closeCBKPlusModals, 100)}
                isClimbg={true}
                title={<p className={SubHeadingStyles}>{t('Get_more_protection')} <span className={SubHeadingStyles2}>{t("CBK+")}</span> {t('upgrade')}</p>}
                subtitle={<p className={`${SubHeaderMsgStyles} mt-[30px]`}>{t('Eligible_Kudzu+_users_may_activate_additional_coverage')}</p>}
                content={<div className=" m-auto md:pt-16 pt-8 pb-5 h-auto w-full flex flex-col">
                    <img src={coveredBykudzuplus1}
                        className="block sm:m-auto mx-auto " alt="" />
                    <div className="w-full flex flex-row justify-between lg:mt-32 md:mt-20 mt-20">
                        <div>
                            <button
                                type="button"
                                className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)] md:relative md:right-[90px]"                                >
                                {t('questions_see_our')} <button onClick={() => { navigate('/Help/FAQ'); logFirebaseEvents("Covered_By_Kudzu_Plus", "Faq_Covered_By_Kudzu_Plus_Clicked", "Faq_Covered_By_Kudzu_Plus_Clicked", "", ""); }}
                                    className="text-[#94C3E8]">{t('faq')}</button>
                            </button>

                            <button
                                type="button"
                                className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)]"
                            >  <button onClick={() => { navigate('/Help/FAQ') }}
                                className="text-[#94C3E8]">{t('faq')}</button>
                            </button>
                        </div>

                        <div className="">
                            <div className="sm:absolute md:right-[-6rem] sm:right-[-4rem] flex sm:justify-end justify-end md:gap-14 sm:gap-8">
                                <button type="button" className="sm:flex hidden font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
 text-[#779CE5]  items-center disabled"  onClick={debounce(handleActivateCoveredByKudzuPlus, 100)}> {t('skip')}</button>

                                <button type="button" className="font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--transactions-filter-blue-text)]
 cursor-pointer flex items-center focus:outline-none  " onClick={debounce(() => { setIsCoveredByKudzuPlusModalOpen1(false); setIsCoveredByKudzuPlusModalOpen2(true); }, 100)} autoFocus> {t('continue')}<img src={appThemeData.arrowWhiteTwofac} className="md:w-[14px] sm:w-[11px]
  md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" alt="Arrow" /> </button></div></div>

                    </div>
                </div>}
            />}
            {isCoveredByKudzuPlusModalOpen2 && <Modal
                isOpen={isCoveredByKudzuPlusModalOpen2}
                onClose={debounce(closeCBKPlusModals, 100)}
                isClimbg={true}
                subtitle={<p className={SubHeadingStyles}>{t('To_maintain_coverage_you’ll_need')} <span className={`${SubHeadingStyles2}`}>{t("100_or_more_in_direct_eposits")}</span> {t('to_your_spending_account_each_month')}</p>}
                content={<div className=" m-auto md:pt-16 pt-8 pb-5 h-auto w-full flex flex-col">
                    <img src={coveredBykudzuplus2}
                        className="block sm:m-auto mx-auto mt-10" alt="" />
                    <div className="w-full flex flex-row justify-between lg:mt-20 md:mt-20 mt-20">
                        <div>
                            <button
                                type="button"
                                className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)] md:relative md:right-[90px]"
                            >
                                {t('questions_see_our')} <button onClick={() => { navigate('/Help/FAQ'); logFirebaseEvents("Covered_By_Kudzu_Plus", "Faq_Covered_By_Kudzu_Plus_Clicked", "Faq_Covered_By_Kudzu_Plus_Clicked", "", ""); }}
                                    className="text-[#94C3E8]">{t('faq')}</button>
                            </button>

                            <button
                                type="button"
                                className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)]"
                            >  <button onClick={() => { navigate('/Help/FAQ') }}
                                className="text-[#94C3E8]">{t('faq')}</button>
                            </button>
                        </div>

                        <div className="">
                            <div className="sm:absolute md:right-[-6rem] sm:right-[-4rem] flex sm:justify-end justify-end md:gap-14 sm:gap-8">
                                <button type="button" className="sm:flex hidden font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
 text-[#779CE5]  items-center disabled"  onClick={debounce(handleActivateCoveredByKudzuPlus, 100)}> {t('skip')}</button>

                                <button type="button" className="font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--transactions-filter-blue-text)]
 cursor-pointer flex items-center focus:outline-none  " onClick={debounce(handleActivateCoveredByKudzuPlus, 100)} autoFocus> {t('activate')}<img src={appThemeData.arrowWhiteTwofac} className="md:w-[14px] sm:w-[11px]
  md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" alt="Arrow" /> </button></div></div>

                    </div> 
                </div>}
            />}
            <Modal
                isOpen={isCoveredByKudzuPlusIneligible}
                onClose={() => {
                    if (isCoveredByKudzuPlusIneligible) {
                        setIsCoveredByKudzuPlusIneligible(false)
                    }
                }}
                isClimbg={true}
                Fullheight={true}
                subtitle={<div className="">
                    <span className={SubHeadingStyles2}>{t('sorry')}, </span>
                    <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
                    <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                        {t("you_need_minimum_100_spending")}  <span className='text-[var(--modal-text-highlight)] cursor-pointer' onClick={ handleTermsClicks }>{t('here')}</span>.</p>
                </div>
                }
                content={<div>

                    <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon}
                        className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" alt='' />

                    <div className="flex flex-col justify-center items-center gap-8 w-full">
                        <button
                            type="button"
                            className=" w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                            onClick={() => { setIsCoveredByKudzuPlusIneligible(false); navigate('/AccountServices/Spending/TransferMoney') }}
                            autoFocus
                        >
                            {t('addMoney')}
                        </button>
                        <button
                            type="button"
                            className={`w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--modal-text-highlight)] cursor-pointer flex justify-center items-center p-4 sm:border-[0px]  border-[#2965FB] border-[2.5px]`}
                            onClick={() => {
                                setIsCoveredByKudzuPlusIneligible(false);
                                navigate('/Climb/ClimbMenu');
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    setIsCoveredByKudzuPlusIneligible(false);
                                    navigate('/Climb/ClimbMenu');
                                    event.stopPropagation();
                                }
                            }}
                        >
                            {t('back_to_climb')}
                        </button>
                    </div>
                </div>}
            />

        </>

    )
}

export default withOidcSecure(ManageCoveredByKudzu)